import { Injectable, inject } from '@angular/core';
import { TransientStateWithRegexps } from '@ps20-frontend/frontend-models';
import { selectRegexp } from '@ps20-frontend/selector';
import { NgRedux } from '@angular-redux3/store';

@Injectable({
  providedIn: 'root',
})
export class RegexpService {
  private readonly ngRedux = inject<NgRedux<TransientStateWithRegexps>>(NgRedux);

  constructor() {}

  public getRegexp(regexpKey: string): RegExp {
    return new RegExp(this.getRegexpAsString(regexpKey));
  }

  public getRegexpAsString(regexpKey: string): string {
    return selectRegexp(this.ngRedux.getState(), regexpKey);
  }
}
